import { inject, injectable } from 'tsyringe';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import { type IBuyerEditRepository } from 'application/repositorySchemas/IBuyerEditRepository';
import { type IBuyerEditClient } from 'interfaceAdapter/gatewaySchemas/IBuyerEditClient';
import { type IEditBuyerProfileClient } from 'interfaceAdapter/gatewaySchemas/IEditBuyerProfileClient';
import { type IBuyerUnPublishClient } from 'interfaceAdapter/gatewaySchemas/IBuyerUnPublishClient';
import { type IBuyerReOpenClient } from 'interfaceAdapter/gatewaySchemas/IBuyerReOpenClient';

@injectable()
export class BuyerEditRepository implements IBuyerEditRepository {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IBuyerEditClient')
        public readonly buyerEditClient: IBuyerEditClient,
        @inject('IEditBuyerProfileClient')
        public readonly editBuyerProfileClient: IEditBuyerProfileClient,
        @inject('IBuyerUnPublishClient')
        public readonly buyerUnPublishClient: IBuyerUnPublishClient,
        @inject('IBuyerReOpenClient')
        public readonly buyerReOpenClient: IBuyerReOpenClient,
    ) {}

    // TODO 型づけをサボっている
    public async edit(buyer: any) {
        const { data, message } = await this.buyerEditClient.post({
            token: this.buyerUserToken.get() || '',
            buyer,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    // TODO 型づけをサボっている
    public async editProfile(buyer: any) {
        const { data, message } = await this.editBuyerProfileClient.post({
            token: this.buyerUserToken.get() || '',
            buyer,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    public async unPublish() {
        const { data, message } = await this.buyerUnPublishClient.post({
            token: this.buyerUserToken.get() || '',
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    public async reOpen() {
        const { data, message } = await this.buyerReOpenClient.post({
            token: this.buyerUserToken.get() || '',
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
